import {IAction} from '../../../interface/action/action.interface';
import {IOpenPopupWindowPayload} from '../../../interface/action/browser-action.interface';
import {returnAction} from '../return-action.util';
import {ActionEnum} from '../../../enum/action.enum';
import {PopupSizeEnum} from '../../../enum/popup-size.enum';

export const openPopupWindow = (url: string, title: string, popupSize: PopupSizeEnum = PopupSizeEnum.NORMAL): IAction<IOpenPopupWindowPayload> =>
  returnAction(ActionEnum.OPEN_POPUP_WINDOW, {url, title, popupSize}, true);
